/**
 * EL REGALO PayMix (theme-native)
 * Prepaid = apply PREPAID5 (5% off). COD = remove that code.
 * No external apps. Checkout payment methods are still Shopify-controlled;
 * this keeps the prepaid discount off COD carts and records preference on the order.
 */
window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();

if (!window.Eurus.loadedScript.has("elr-paymix.js")) {
  window.Eurus.loadedScript.add("elr-paymix.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      const PREPAID_CODE = (window.ELR_PAYMIX && window.ELR_PAYMIX.code) || "PREPAID5";
      const PREPAID_LABEL = (window.ELR_PAYMIX && window.ELR_PAYMIX.label) || "5% off";

      Alpine.store("xPayMix", {
        method: null, // 'prepaid' | 'cod'
        loading: false,
        message: "",
        error: "",
        code: PREPAID_CODE,
        label: PREPAID_LABEL,

        initFromCart() {
          const attrEl = document.getElementById("elr-paymix-cart-attrs");
          if (attrEl) {
            try {
              const attrs = JSON.parse(attrEl.textContent || "{}");
              if (attrs.paymix_method === "prepaid" || attrs.paymix_method === "cod") {
                this.method = attrs.paymix_method;
              }
            } catch (e) {}
          }
          // If prepaid code already applied, reflect that
          this.syncFromDiscountCodes();
          document.addEventListener("eurus:cart:discount-code:change", () => {
            this.syncFromDiscountCodes();
          });
        },

        syncFromDiscountCodes() {
          try {
            Alpine.store("xCouponCodeDetail")?.getDiscountCode?.();
            const codes = Alpine.store("xCouponCodeDetail")?.appliedDiscountCodes || [];
            const hasPrepaid = codes.some(
              (c) => String(c).toLowerCase() === this.code.toLowerCase()
            );
            if (hasPrepaid) this.method = "prepaid";
          } catch (e) {}
        },

        sectionsPayload() {
          try {
            return Alpine.store("xCartHelper")
              .getSectionsToRender()
              .map((section) => section.id);
          } catch (e) {
            return [];
          }
        },

        async updateCart(payload) {
          const body = {
            ...payload,
            sections: this.sectionsPayload(),
          };
          const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (data.status === "422") {
            throw new Error(data.message || "Could not update cart");
          }
          try {
            Alpine.store("xCartHelper").reRenderSections(data.sections);
          } catch (e) {}
          if (Array.isArray(data.discount_codes)) {
            const applied = [];
            data.discount_codes.forEach((code) => {
              if (code.applicable) applied.push(code.code);
            });
            try {
              Alpine.store("xCouponCodeDetail").appliedDiscountCodes = applied;
              document.cookie = `eurus_discount_code=${applied.join(",")}; path=/`;
            } catch (e) {}
          }
          document.dispatchEvent(new CustomEvent("eurus:cart:discount-code:change"));
          return data;
        },

        currentDiscountList(removePrepaid) {
          let codes = [];
          try {
            Alpine.store("xCouponCodeDetail")?.getDiscountCode?.();
            codes = [
              ...(Alpine.store("xCouponCodeDetail")?.appliedDiscountCodes || []),
            ];
          } catch (e) {}
          codes = codes
            .map((c) => String(c).trim())
            .filter(Boolean)
            .filter((c) => c.toLowerCase() !== this.code.toLowerCase() || !removePrepaid);
          return codes;
        },

        async selectPrepaid() {
          if (this.loading) return;
          this.loading = true;
          this.error = "";
          this.message = "";
          try {
            const codes = this.currentDiscountList(true);
            if (!codes.map((c) => c.toLowerCase()).includes(this.code.toLowerCase())) {
              codes.push(this.code);
            }
            await this.updateCart({
              discount: codes.join(","),
              attributes: {
                paymix_method: "prepaid",
                paymix_code: this.code,
                paymix_note: `Pay online selected — ${this.label} via ${this.code}. Not for COD.`,
              },
              note: `Payment preference: Pay online (${this.code} ${this.label}). Do not use COD.`,
            });
            this.method = "prepaid";
            this.message = `${this.code} applied — pay online at checkout to keep ${this.label}.`;
          } catch (e) {
            this.error =
              e.message ||
              `Could not apply ${this.code}. Create the discount in Admin if missing.`;
          } finally {
            this.loading = false;
          }
        },

        async selectCod() {
          if (this.loading) return;
          this.loading = true;
          this.error = "";
          this.message = "";
          try {
            const codes = this.currentDiscountList(true);
            await this.updateCart({
              discount: codes.join(","),
              attributes: {
                paymix_method: "cod",
                paymix_code: "",
                paymix_note: "Cash on Delivery selected — prepaid discount removed.",
              },
              note: "Payment preference: Cash on Delivery (no prepaid discount).",
            });
            this.method = "cod";
            this.message = "COD selected. Prepaid discount removed.";
          } catch (e) {
            this.error = e.message || "Could not update COD preference.";
          } finally {
            this.loading = false;
          }
        },

        async ensureBeforeCheckout(event) {
          if (!this.method) {
            // Default to prepaid offer visibility but don't block
            return true;
          }
          if (this.method === "prepaid") {
            // Ensure code still applied
            Alpine.store("xCouponCodeDetail")?.getDiscountCode?.();
            const codes = Alpine.store("xCouponCodeDetail")?.appliedDiscountCodes || [];
            const has = codes.some(
              (c) => String(c).toLowerCase() === this.code.toLowerCase()
            );
            if (!has) {
              event?.preventDefault?.();
              await this.selectPrepaid();
              return false;
            }
          }
          if (this.method === "cod") {
            Alpine.store("xCouponCodeDetail")?.getDiscountCode?.();
            const codes = Alpine.store("xCouponCodeDetail")?.appliedDiscountCodes || [];
            const has = codes.some(
              (c) => String(c).toLowerCase() === this.code.toLowerCase()
            );
            if (has) {
              event?.preventDefault?.();
              await this.selectCod();
              // retry checkout after COD cleanup
              const btn = document.getElementById("checkout-submit");
              if (btn) setTimeout(() => btn.click(), 150);
              return false;
            }
          }
          return true;
        },
      });

      Alpine.data("xPayMixBox", () => ({
        init() {
          Alpine.store("xPayMix").initFromCart();
        },
      }));
    });
  });
}
